import * as types from './types';

export const invoiceReminderMutations = {
  [types.InvoiceReminders.SET.ALL] (state, payload) {
    state.invoiceReminderList = payload;
  },
  [types.SelectedInvoiceReminder.SET.SINGLE] (state, payload) {
    state.selectedInvoiceReminder = payload;
  },
}